<!-- 自律委员会 -->
<template>
  <div>
    <div v-loading="loading" class="right_box">
      <div
        v-for="(it, i) in infoList"
        :key="i"
        class="item"
        @click="goDetail(it)"
      >
        <img v-if="it.thumb" :src="it.thumb" style="width: 26%" />
        <div :style="{ width: it.thumb ? '70%' : '100%' }">
          <div class="title single">{{ it.title }}</div>
          <div class="time">{{ it.date }}</div>
          <div class="article">
            {{ it.description }}
          </div>
        </div>
      </div>
      <div v-if="infoList.length == 0" class="common_excel_no_more">
        暂无内容~
      </div>
      <Page
        v-if="infoList.length != 0"
        :current="params.pageNo"
        :page-size="params.pageSize"
        :total="total"
        class="common_page_box"
        show-total
        @on-change="changePage"
      ></Page>
    </div>
  </div>
</template>

<script>
import { getArticle } from "@/api/home/index";
export default {
  name: "home",
  components: {},
  props: {
    locationList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      infoList: [],
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 20,
      },
      loading: false,
    };
  },
  mounted() {
    this.getArticle();
  },
  methods: {
    /* ====================数据请求部分========================== */
    getArticle() {
      this.loading = true;
      getArticle({
        catid: 401,
        ...this.params,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.infoList = res.result.records;
          this.loading = false;
          if (res.result.records.length > 0) {
            this.$router.push({
              name: "news_detail",
              query: {
                id: res.result.records[0].id,
              },
              params: {
                locationList: encodeURIComponent(
                  JSON.stringify(this.locationList),
                ),
                bgNum: 1,
              },
            });
          }
          this.total = res.result.total;
        } else {
          this.infoList = [];
        }
      });
    },
    /* ====================页面交互部分========================== */
    getMenu(e) {
      this.catid = e;
      this.getArticle();
    },
    changePage(e) {
      this.params.pageNo = e;
      this.getArticle();
    },
    goDetail(it) {
      this.$router.push({
        name: "news_detail",
        query: {
          id: it.id,
        },
        params: {
          locationList: encodeURIComponent(JSON.stringify(this.locationList)),
          bgNum: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.right_box {
  .item {
    border-bottom: 1px solid #eee;
    padding: 10px;
    padding-bottom: 30px;
    margin-bottom: 30px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    -webkit-transition: all 0.2s ease-in;
    -moz-transition: all 0.2s ease-in;
    -o-transition: all 0.2s ease-in;

    img {
      width: 250px;
      height: 180px;
      margin-right: 30px;
    }

    .title {
      font-size: 20px;
      color: #000000;
      text-align: left;
    }

    .time {
      color: #575b66;
      font-size: 15px;
      padding: 10px 0;
    }

    .article {
      color: #9e9e9e;
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .item:hover {
    box-shadow: 5px 5px 20px #9e9e9e;
  }
}
/* 手机 */
@media only screen and (max-width: 800px) {
  .right_box {
    > div {
      padding: 10px !important;
      margin: 0 !important;
    }
    .title {
      font-size: 15px !important;
      width: 300px !important;
    }
    .time {
      padding: 0 !important;
      font-size: 13px !important;
    }
  }
}
</style>
